import script from "./list-select-menu-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./list-select-menu-item.vue?vue&type=script&lang=ts&setup=true"

import "./list-select-menu-item.vue?vue&type=style&index=0&id=60e184ca&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e184ca"]])

export default __exports__